export default __webpack_public_path__ + "static/media/logo-dark.7a0921e8.png";